import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel, KeyOutlined } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Stack,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    Tooltip,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import { axiosInstance } from 'utils/axios';

import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

const successAlert = (message) => {
    toast.success(message, {
        position: toast.POSITION.TOP_CENTER
    });
};

const errorAlert = (message) => {
    toast.error(message, {
        position: toast.POSITION.TOP_CENTER
    });
};

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'dateLabel', label: 'Date Label', minWidth: 170, type: 'date' },
    {
        id: 'clientName',
        label: 'Client Name',
        minWidth: 170
    },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 170 },
    {
        id: 'packageName',
        label: 'Package Name',
        minWidth: 170
    },
    {
        id: 'salesAmount',
        label: 'Sales Amount',
        minWidth: 70
    },
    {
        id: 'payoutPercentageString',
        label: 'Payout Percentage',
        minWidth: 70
    },
    {
        id: 'lockIncentivePercentageString',
        label: 'Lock Incentive',
        minWidth: 120
    },
    {
        id: 'amount',
        label: 'Amount',
        minWidth: 70
    },
    {
        id: 'statusName',
        label: 'Status',
        minWidth: 70
    },
    {
        id: 'bankVendorName',
        label: 'Bank Vender name',
        minWidth: 120
    },
    {
        id: 'bankAccountHolderName',
        label: 'Bank Account Holder Name',
        minWidth: 170
    },
    {
        id: 'bankAccountNumber',
        label: 'Bank Account Number',
        minWidth: 170
    },
    {
        id: 'bonusPercentage',
        label: 'Bonus Percentage',
        minWidth: 170
    },
    {
        id: 'bonusAmount',
        label: 'Bonus Amount',
        minWidth: 170
    },
    {
        id: 'createdBy',
        label: 'Created By',
        minWidth: 170
    },
    {
        id: 'createdDate',
        label: 'Created Date',
        minWidth: 170,
        type: 'date'
    },
    {
        id: 'updatedBy',
        label: 'Updated By',
        minWidth: 170
    },
    {
        id: 'updatedDate',
        label: 'Updated Date',
        minWidth: 170,
        type: 'date'
    }
];

function createData(count, name, payout, start, end, active) {
    return { count, name, payout, start, end, active };
}

const rows = [
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active')
];

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const InsertPackage = () => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    color: 'white',
                    marginLeft: 'auto',
                    marginBottom: '20px',
                    marginRight: '20px'
                }}
            >
                Insert Package
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Insert Package
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '300px',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        Package Name :
                                    </Typography>
                                    <TextField id="outlined-basic" variant="outlined" />
                                </Box>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        Payout Percentage :
                                    </Typography>
                                    <input type="number" style={{ width: '100%', height: '50px', borderRadius: '10px' }} />
                                </Box>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        Start Date :
                                    </Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    error: false
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        End Date :
                                    </Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    error: false
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        Status :
                                    </Typography>
                                    <FormControl fullWidth>
                                        <Select labelId="demo-simple-select-label" id="demo-simple-select" defaultValue="">
                                            {
                                                // customerStatus.map((item,index) =>(
                                                //   <MenuItem value={item.name} key={index}>{item.name}</MenuItem>
                                                // ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '50px'
                        }}
                    >
                        Create
                    </Button>
                </Box>
            </Modal>
        </>
    );
};

const ViewDetailsModal = ({ id }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const token = useSelector(selectCurrentToken);
    const [payoutDetails, setPayoutDetails] = useState({});

    const fetchPayoutDetails = async () => {
        try {
            const res = await axiosInstance.get(`/Payout/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setPayoutDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (open) {
            fetchPayoutDetails();
        }
    }, [open]);

    return (
        <div>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ContactPage />
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Payout Details
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>

                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '500px',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Date Label :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {payoutDetails.dateLabel &&
                                            `${payoutDetails.dateLabel?.split('T')[0]} 
                ${new Date('1970-01-01T' + payoutDetails.dateLabel?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                    timeZone: 'UTC',
                    hour12: true,
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Sales Amount : <span style={{ fontWeight: 600 }}>{payoutDetails.salesAmount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Payout Percentage : <span style={{ fontWeight: 600 }}>{payoutDetails.payoutPercentageString}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Amount : <span style={{ fontWeight: 600 }}>{payoutDetails.amount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Status : <span style={{ fontWeight: 600 }}>{payoutDetails.statusName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                {/* <Typography sx={{
                fontSize:"16px"
              }}
              >Created By : <span style={{fontWeight:600}}>{payoutDetails.createdBy}</span>
              </Typography> */}
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created By : <span style={{ fontWeight: 600 }}>{payoutDetails.createdBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {payoutDetails.createdDate &&
                                            `${payoutDetails.createdDate?.split('T')[0]} 
                ${new Date('1970-01-01T' + payoutDetails.createdDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                    timeZone: 'UTC',
                    hour12: true,
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated By : <span style={{ fontWeight: 600 }}>{payoutDetails.updatedBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {payoutDetails.updatedDate &&
                                            `${payoutDetails.updatedDate?.split('T')[0]} 
                ${new Date('1970-01-01T' + payoutDetails.updatedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                    timeZone: 'UTC',
                    hour12: true,
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                })}`}
                                    </span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={12} sx={{ mt: 3 }}>
                                <Typography
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Customer Details
                                </Typography>
                            </Grid>

                            {/* Customer ID */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Customer ID : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.id}</span>
                                </Typography>
                            </Grid>

                            {/* Name */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Name : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.name}</span>
                                </Typography>
                            </Grid>

                            {/* Bank Vendor ID */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Bank Vendor ID : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.bankVendorID}</span>
                                </Typography>
                            </Grid>

                            {/* Bank Vendor Name */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Bank Vendor Name :{' '}
                                    <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.bankVendorName}</span>
                                </Typography>
                            </Grid>

                            {/* Bank Account */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Bank Account : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.bankAccount}</span>
                                </Typography>
                            </Grid>

                            {/* Bank Holder Name */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Bank Holder Name :{' '}
                                    <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.bankHolderName}</span>
                                </Typography>
                            </Grid>

                            {/* Phone Number */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Phone Number : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.phoneNumber}</span>
                                </Typography>
                            </Grid>

                            {/* NRC */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    NRC : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.nrc}</span>
                                </Typography>
                            </Grid>

                            {/* Birthday */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Birthday : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.birthday}</span>
                                </Typography>
                            </Grid>

                            {/* Username */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Username : <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.userName}</span>
                                </Typography>
                            </Grid>

                            {/* Total Deposit Amount */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Total Deposit Amount :{' '}
                                    <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.totalDepositAmount}</span>
                                </Typography>
                            </Grid>

                            {/* Total Payout Amount */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Total Payout Amount :{' '}
                                    <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.totalPayoutAmount}</span>
                                </Typography>
                            </Grid>

                            {/* Total PNL Amount */}
                            <Grid item container xs={12} md={6} sx={{ my: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Total PNL Amount :{' '}
                                    <span style={{ fontWeight: 600 }}>{payoutDetails?.customerDetail?.totalPNLAmount}</span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

const DailyPayoutRecords = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true);
    const [payoutStatuses, setPayoutStatuses] = useState([]);
    const [payouts, setPayouts] = useState([]);

    const [filterPayoutFrom, setFilterPayoutFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterPayoutTo, setFilterPayoutTo] = useState(dayjs());
    const [filterPayoutClientName, setFilterPayoutClientName] = useState('');
    const [filterPayoutCustomerLoginUserName, setFilterPayoutCustomerLoginUserName] = useState('');
    const [filterPayoutStatus, setFilterPayoutStatus] = useState('');
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [customerLoginUserNamesOptions, setCustomerLoginUserNamesOptions] = useState([]);

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const [generateBtnDisabled, setGenerateBtnDisabled] = useState(false);
    const [isAllowFilterUserName, setIsAllowFilterUserName] = useState('');
    const [filterUserName, setFilterUserName] = useState('');
    const [usersList, setUsersList] = useState([]);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    //fetch customer names for autocomplete start
    // const fetchCustomerNamesOptions = async () => {
    //     try {
    //         const res = await axiosInstance.get('/Customer/Names', {
    //             headers: {
    //                 Authorization: `Bearer ${token}`
    //             }
    //         });
    //         if (res.status === 200) {
    //             setCustomerNameOptions(res.data);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };
    //fetch customer names for autocomplete end

    const fetchCustomerLoginUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/LoginUserNames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerLoginUserNamesOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Is Allow Filter UserName
    const fetchIsAllowFilterUserName = async () => {
        try {
            const res = await axiosInstance.get(`/isAllowFilterUserName`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowFilterUserName(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    //fetch customer names for autocomplete start
    const fetchUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Usernames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsersList(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //generate payout start
    const generatePayout = async () => {
        setGenerateBtnDisabled(true);
        try {
            const res = await axiosInstance.post(
                '/GeneratePayout',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('Generated payout successfully.');
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setGenerateBtnDisabled(false);
        }
    };
    //generate payout end

    //fetch payout status start
    const fetchPayoutStatuses = async () => {
        try {
            const res = await axiosInstance.get('/PayoutStatus', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setPayoutStatuses(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch payout status end

    const [prevPages, setPrevPages] = useState([]);
    const [newPage, setNewPage] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        // if (newPage >= page) {
        //     setPage(newPage);

        //     if (!prevPages.includes(newPage)) {
        //         setPrevPages((prevPages) => [...prevPages, newPage]);
        //         setNewPage(newPage); // Update the newPage state
        //     }
        // } else {
        //     setPage(newPage);
        // }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        // setRowsPerPage(+event.target.value);
        // setPrevPages([]);
        // setPayouts([]);
        // setPage(0);
    };
    useEffect(() => {
        fetchPayouts();
    }, [newPage, rowsPerPage]);

    //fetch payouts start
    const [fetchPayoutLoading, setPayoutLoading] = useState(false);
    const fetchPayouts = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        if (!filterPayoutFrom.isValid() || !filterPayoutTo.isValid()) {
            warningAlert('Please fill the required fields.');
            return;
        }
        let fetchPayoutURL = `/Payout/All?dateLabelFrom=${filterPayoutFrom.format('YYYY-MM-DD')}&dateLabelTo=${filterPayoutTo.format(
            'YYYY-MM-DD'
        )}`;

        if (filterPayoutCustomerLoginUserName!== '') {
            fetchPayoutURL += `&customerLoginUserName=${filterPayoutCustomerLoginUserName}`;
        }
        if (filterPayoutStatus !== '') {
            fetchPayoutURL += `&statusID=${filterPayoutStatus}`;
        }
        if (filterUserName !== '') {
            fetchPayoutURL += `&searchUserID=${parseInt(filterUserName, 10)}`;
        }
        setPayoutLoading(true);
        try {
            const res = await axiosInstance.get(fetchPayoutURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                // setPayouts((payouts) => [...payouts, ...res.data]);
                setPayouts(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setPayoutLoading(false);
        }
    };
    //fetch payouts end

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterPayoutFrom.isValid() || !filterPayoutTo.isValid()) {
            warningAlert('Please fill the required fields.');
            return;
        }
        let fetchPayoutURL = `/Payout/All?dateLabelFrom=${filterPayoutFrom.format('YYYY-MM-DD')}&dateLabelTo=${filterPayoutTo.format(
            'YYYY-MM-DD'
        )}`;

        if (filterPayoutCustomerLoginUserName !== '') {
            fetchPayoutURL += `&customerLoginUserName=${filterPayoutCustomerLoginUserName}`;
        }
        if (filterPayoutStatus !== '') {
            fetchPayoutURL += `&statusID=${filterPayoutStatus}`;
        }
        if (filterUserName !== '') {
            fetchPayoutURL += `&searchUserID=${parseInt(filterUserName, 10)}`;
        }

        try {
            const res = await axiosInstance.get(fetchPayoutURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `DailyPayoutRecords_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    //update payout start
    const UpdatePayout = ({ payout }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [updateDateLabel, setUpdateDateLabel] = useState(dayjs(payout.dateLabel));
        const [updateAmount, setUpdateAmount] = useState(payout.amount);
        const [updateStatus, setUpdateStatus] = useState(payout.statusID);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updatePayoutLoading, setUpdatePayoutLoading] = useState(false);

        const submitUpdatePayout = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            if (!updateDateLabel.isValid() || parseFloat(updateAmount) === 0 || updateStatus === '') {
                warningAlert('Please fill all required fields.');
                return;
            }
            setUpdatePayoutLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/Payout',
                    {
                        payoutID: payout.id,
                        dateLabel: updateDateLabel.format('YYYY-MM-DD'),
                        amount: updateAmount,
                        statusID: updateStatus
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales updated successfully.');
                    fetchPayouts();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdatePayoutLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updatePayoutLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Payout
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Date Label :
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={updateDateLabel}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setUpdateDateLabel(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateAmount}
                                                onChange={(e) => setUpdateAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Status :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateStatus}
                                                onChange={(e) => setUpdateStatus(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Status
                                                </MenuItem>
                                                {payoutStatuses.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdatePayout()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //update payout end

    const BatchApprove = () => {
        const [batchStartDate, setBatchStartDate] = useState('');
        const [batchEndDate, setBatchEndDate] = useState('');
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false); // Initialize as false
        const [loading, setLoading] = useState(false); // Add loading state

        const submitInsertBatchApproveDate = async () => {
            if (batchStartDate === '' || batchEndDate === '') {
                warningAlert('Please fill all required fields.');
                return;
            }

            setLoading(true); // Set loading to true
            setInsertBtnDisabled(true); // Disable the button during submission

            const formattedBatchStartDate = dayjs(batchStartDate).format('YYYY-MM-DD');
            const formattedBatchEndDate = dayjs(batchEndDate).format('YYYY-MM-DD');
            try {
                const res = await axiosInstance.post(
                    '/BatchApprove/PendingPayout',
                    {
                        startDate: formattedBatchStartDate,
                        endDate: formattedBatchEndDate
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    handleClose(); // Close the modal on success
                    fetchPayouts();
                    successAlert('Batch Approve Success.');
                } else {
                    errorAlert('Something went wrong');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false); // Reset loading state after request is completed
                setInsertBtnDisabled(false); // Re-enable the button
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginBottom: '20px',
                        marginRight: '20px',
                        marginTop: '20px'
                    }}
                >
                    Batch Approve
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Batch Approve
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box id="modal-modal-description" sx={{}}>
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Start Date :
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={batchStartDate}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setBatchStartDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                End Date :
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={batchEndDate}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setBatchEndDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertBatchApproveDate()}
                                disabled={insertBtnDisabled}
                            >
                                Approve Batch
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };

    //payout table start
    function StickyHeadTable() {
        const [checkedRows, setCheckedRows] = useState([]);
        const token = useSelector(selectCurrentToken);

        useEffect(() => {
            const storedCheckedRows = localStorage.getItem('checkedRows');
            if (storedCheckedRows) {
                setCheckedRows(JSON.parse(storedCheckedRows));
            }
        }, []);

        const handleCheckboxChange = async (id) => {
            try {
                const res = await axiosInstance.put(
                    `/Payout/${id}/Approve`,
                    { id: id },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200 && res.data === true) {
                    const updatedCheckedRows = checkedRows.includes(id)
                        ? checkedRows.filter((rowId) => rowId !== id)
                        : [...checkedRows, id];

                    // Update state and local storage
                    setCheckedRows(updatedCheckedRows);
                    localStorage.setItem('checkedRows', JSON.stringify(updatedCheckedRows));

                    successAlert('Update approve payout success.');
                    // fetchPayouts();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            }
        };

        return (
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchPayoutLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {payouts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                {columns.map((column) => {
                                                    let value = row[column.id];
                                                    if (column.type && column.type === 'date') {
                                                        if (value) {
                                                            const timeString12hr = new Date(
                                                                '1970-01-01T' + value.split('T')[1] + 'Z'
                                                            ).toLocaleTimeString('en-US', {
                                                                timeZone: 'UTC',
                                                                hour12: true,
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric'
                                                            });
                                                            value = `${value.split('T')[0]} ${timeString12hr}`;
                                                        }
                                                    }
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {value}
                                                        </TableCell>
                                                    );
                                                })}
                                                {isUserAllowEdit &&
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px'
                                                            }}
                                                        >
                                                            <ViewDetailsModal id={row.id} />
                                                            <UpdatePayout payout={row} />
                                                            <Tooltip title="Approve Payout">
                                                                <Checkbox
                                                                    checked={checkedRows.includes(row.id)}
                                                                    size="small"
                                                                    onChange={() => handleCheckboxChange(row.id)}
                                                                />
                                                            </Tooltip>
                                                        </Box>
                                                    </TableCell>
                                                }
                                                {/* <TableCell><button><ManageAccounts /></button></TableCell> */}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={payouts.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                )}
            </Box>
        );
    }
    //payout table end

    useEffect(() => {
        setLoading(false);

        Promise.all([
            fetchPayoutStatuses(),
            fetchPayouts(),
            fetchIsAllowFilterUserName(),
            // fetchCustomerNamesOptions(),
            fetchCustomerLoginUserNamesOptions(),
            fetchUserNamesOptions(),
            fetchIsUserAllowEdit()
        ]).catch((error) => {
            // Handle errors if any of the promises fail
            console.error('An error occurred:', error);
        });
    }, []);

    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Grid container item xs={12}>
            {isUserAllowEdit &&
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                    <BatchApprove />
                    {/* <Button
                        onClick={() => generatePayout()}
                        sx={{
                            border: 'none',
                            backgroundColor: deepPurple[500],
                            color: 'white',
                            // marginLeft: 'auto',
                            marginBottom: '20px',
                            marginRight: '20px'
                        }}
                        disabled={generateBtnDisabled}
                    >
                        Generate Payout
                    </Button> */}
                </Box>
            }

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '20px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>Label From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPayoutFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPayoutFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>Label To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPayoutTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPayoutTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer Login User Name :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={filterPayoutCustomerLoginUserName}
                            onChange={(event, newValue) => {
                                setFilterPayoutCustomerLoginUserName(newValue);
                            }}
                            inputValue={filterPayoutCustomerLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setFilterPayoutCustomerLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNamesOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                {/* User Name */}
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            User Name :
                        </Typography>

                        <Select
                            disabled={!isAllowFilterUserName}
                            displayEmpty
                            value={filterUserName}
                            onChange={(e) => setFilterUserName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Username
                            </MenuItem>
                            {usersList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.userName}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Status :
                        </Typography>
                        <Select displayEmpty value={filterPayoutStatus} onChange={(e) => setFilterPayoutStatus(e.target.value)}>
                            <MenuItem value="">Select Payout Status</MenuItem>
                            {payoutStatuses.map((item, index) => (
                                <MenuItem value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
            </Grid>
            <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '15px',
                        width: '50%',
                        marginLeft: 'auto'
                    }}
                >
            <Button
                variant="contained"
                sx={{
                    display: 'block',
                    mx: 'auto',
                    width: '150px',
                    backgroundColor: deepPurple[500],
                    marginTop: '20px',
                    marginBottom: '30px'
                }}
                onClick={() => fetchPayouts()}
                disabled={filterBtnDisabled}
            >
                Filter
            </Button>
            {isUserAllowEdit &&
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => exportDataAsXlsx()}
                    disabled={filterBtnDisabled}
                >
                    Export Data
                </Button>
            }
            </Box>

            <StickyHeadTable />
        </Grid>
    );
};

export default DailyPayoutRecords;
